module.exports = __webpack_public_path__ + "static/media/m_img.33934323.png";